import React, { Fragment } from "react";
import useForm from "react-hook-form";
import { connect } from "react-redux";
import store from "store";
import ImageUpload from "./imageUpload";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";

const ProductForm = (props) => {
  const { register, handleSubmit, errors } = useForm(); // initialise the hook
  var {
    info,
    onChangeUrl,
    searchProductUrl,
    searchUrlStatus,
    isEdit,
    imageUrl,
    onChangeImage,
    removeImage,
    onChangeSubCategory,
  } = props;
  console.log({ info });
  const onSubmit = (data) => {
    if (data !== "") {
      // onSubmitForm()/
      props.onClickConfirm(data);
    } else {
      errors.showMessages();
    }
  };

  return (
    <Fragment>
      <div className="container-fluid">
        <div className="card-body">
          <form
            id="product-form"
            className="needs-validation"
            noValidate=""
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className="row">
              {/******** Fields *******/}
              <div className="col-12 col-md-6 mb-2">
                {/***** ategory Name  *****/}
                <div className="col-12">
                  <label className="mb-2">
                    Category Name
                    <span>*</span>
                  </label>
                  <input
                    className="form-control mb-2"
                    name="name"
                    type="text"
                    defaultValue={info.name}
                    placeholder="Category name..."
                    onChange={(e) => onChangeUrl(e.target.value, null, null)}
                    ref={register({ required: true })}
                  />
                  <span>{errors.name && "Category Name is required"}</span>
                </div>

                {/******* Add Sub-Category *****/}
                <div className="col-12">
                  <label className="mb-2">
                    Add Sub-Category
                    <span>*</span>
                  </label>
                  <Typeahead
                    allowNew
                    id="custom-selections-example"
                    multiple
                    newSelectionPrefix="Add a new sub-category: "
                    selected={info.subCategory}
                    options={info.subCategory || []}
                    // onInputChange={(input) => console.log({ input }, "---$$$")}
                    onChange={(value) => {
                      onChangeSubCategory(value);
                    }}
                    placeholder="Sub-category..."
                  />
                  <span style={{ color: "#ff5370" }}>
                    {errors.product && "Product is required"}
                  </span>
                </div>

                {/******** Page Title  ******/}
                <div className="col-12 mt-2">
                  <label className="mb-2">
                    Page Title
                    <span>*</span>
                  </label>
                  <input
                    className="form-control mb-2"
                    name="sTitle"
                    type="text"
                    defaultValue={info.sTitle || ""}
                    placeholder="Page title..."
                    ref={register({ required: true })}
                  />
                  <span>{errors.sTitle && "Page Title is required"}</span>
                </div>
              </div>

              {/******* Image upload ******/}
              <div className="col-12 col-md-6 mb-2">
                <label className="mb-2">
                  Cover Image
                  <span>*</span>
                </label>
                <div className="row">
                  <div className="col-md-2"></div>
                  <div className="col-md-8">
                    <ImageUpload
                      imageUrl={imageUrl}
                      onChangeImage={onChangeImage}
                      removeImage={removeImage}
                    />
                  </div>
                </div>
              </div>

              {/***** Page url ******/}
              <div className="col-12 col-md-6 mb-2">
                <label className="mb-2">
                  Page Url
                  <span>*</span>
                </label>
                <input
                  className="form-control"
                  name="sUrl"
                  type="text"
                  value={info.sUrl || ""}
                  placeholder="Page url..."
                  onChange={(e) => onChangeUrl(null, e.target.value)}
                  ref={register({ required: true })}
                />
                <span>{errors.sUrl && "Page Url is required"}</span>
              </div>

              {/****** Page keyword ******/}
              <div className="col-12 col-md-6 mb-2">
                <label className="mb-2">
                  Page Keyword
                  <span>*</span>
                </label>
                <input
                  className="form-control"
                  name="sKeyword"
                  type="text"
                  defaultValue={info.sKeyword || ""}
                  placeholder="Page keyword..."
                  ref={register({ required: true })}
                />
                <span>{errors.sKeyword && "Page Keyword is required"}</span>
              </div>

              {/****** Page description ******/}
              <div className="col-md-12 mb-3">
                <label className="mb-2">
                  Page Description
                  <span>*</span>
                </label>
                <textarea
                  className="form-control"
                  name="shortDescription"
                  type="text"
                  row="6"
                  defaultValue={info.shortDescription}
                  placeholder="Page description..."
                  ref={register({
                    required: true,
                  })}
                  style={{ height: "64px" }}
                />
                <span style={{ color: "#ff5370" }}>
                  {errors.shortDescription && "Short description is required"}
                </span>
              </div>

            </div>

            {/* <div className="form-row">
              <div className="col-md-6 mb-12 p-t-5  p-b-5">
                <div className="  p-b-5">
                  {" "}
                  <label htmlFor="validationCustom02" className="p-l-15 p-r-15">
                    Category Name
                    <span>*</span>
                  </label>
                  <div className=" p-l-15 p-r-15">
                    <input
                      className="form-control"
                      name="name"
                      type="text"
                      defaultValue={info.name}
                      placeholder="Category name..."
                      onChange={(e) => onChangeUrl(e.target.value, null, null)}
                      ref={register({ required: true })}
                    />
                    <span>{errors.name && "Category Name is required"}</span>
                    <div className="valid-feedback">Looks good!</div>
                  </div>
                </div>
                <div className="p-t-5  p-b-5">
                  <label
                    htmlFor="validationCustom01"
                    className="p-l-15 p-r-15 "
                  >
                    Add Sub-Category
                    <span>*</span>
                  </label>
                  <div className=" p-l-15 p-r-15">
                    <Typeahead
                      allowNew
                      id="custom-selections-example"
                      multiple
                      newSelectionPrefix="Add a new sub-category: "
                      selected={info.subCategory}
                      options={info.subCategory || []}
                      // onInputChange={(input) => console.log({ input }, "---$$$")}
                      onChange={(value) => {
                        onChangeSubCategory(value);
                      }}
                      placeholder="Sub-category..."
                    />
                    <span style={{ color: "#ff5370" }}>
                      {errors.product && "Product is required"}
                    </span>
                    <div className="valid-feedback">Looks good!</div>
                  </div>
                </div>
                <div className="p-t-5  p-b-5">
                  {" "}
                  <label htmlFor="validationCustom02" className="p-l-15 p-r-15">
                    Page Title
                    <span>*</span>
                  </label>
                  <div className=" p-l-15 p-r-15">
                    <input
                      className="form-control"
                      name="sTitle"
                      type="text"
                      defaultValue={info.sTitle || ""}
                      placeholder="Page title..."
                      ref={register({ required: true })}
                    />
                    <span>{errors.sTitle && "Page Title is required"}</span>
                    <div className="valid-feedback">Looks good!</div>
                  </div>{" "}
                </div>
              </div>
              <div className="col-md-6 mb-12 p-t-5  p-b-5  ">
                <label htmlFor="validationCustom01" className="p-l-15 p-r-15">
                  Cover Image
                  <span>*</span>
                </label>
                <div className="row">
                  <div className="col-md-2 mb-2 text-center"></div>
                  <div className="col-md-8 mb-12 text-center">
                    <ImageUpload
                      imageUrl={imageUrl}
                      onChangeImage={onChangeImage}
                      removeImage={removeImage}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-6 mb-12 p-t-5  p-b-5">
                <label htmlFor="validationCustom02" className="p-l-15 p-r-15">
                  Page Url
                  <span>*</span>
                </label>
                <div className=" p-l-15 p-r-15">
                  <input
                    className="form-control"
                    name="sUrl"
                    type="text"
                    value={info.sUrl || ""}
                    placeholder="Page url..."
                    onChange={(e) => onChangeUrl(null, e.target.value)}
                    ref={register({ required: true })}
                  />
                  <span>{errors.sUrl && "Page Url is required"}</span>
                  <div className="valid-feedback">Looks good!</div>
                </div>
              </div>
              <div className="col-md-6 mb-12 p-t-5  p-b-5">
                <label htmlFor="validationCustom02" className="p-l-15 p-r-15">
                  Page Keyword
                  <span>*</span>
                </label>
                <div className=" p-l-15 p-r-15">
                  <input
                    className="form-control"
                    name="sKeyword"
                    type="text"
                    defaultValue={info.sKeyword || ""}
                    placeholder="Page keyword..."
                    ref={register({ required: true })}
                  />
                  <span>{errors.sKeyword && "Page Keyword is required"}</span>
                  <div className="valid-feedback">Looks good!</div>
                </div>
              </div>

              <div className="col-md-12 mb-12 p-t-5  p-b-5">
                <label htmlFor="validationCustom01" className="p-l-15 p-r-15">
                  Page Description
                  <span>*</span>
                </label>
                <div className=" p-l-15 p-r-15">
                  <textarea
                    className="form-control"
                    name="shortDescription"
                    type="text"
                    row="6"
                    defaultValue={info.shortDescription}
                    placeholder="Page description..."
                    ref={register({
                      required: true,
                    })}
                    style={{ height: "64px" }}
                  />
                  <span style={{ color: "#ff5370" }}>
                    {errors.shortDescription && "Short description is required"}
                  </span>
                  <div className="valid-feedback">Looks good!</div>
                </div>
              </div>
            </div> */}

            <div className="p-15 float-end">
              <button className="btn btn-primary " type="submit" style={{ padding: "6px 28px", fontSize: "14px" }}>
                {isEdit ? "Update" : "Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </Fragment>
  );
};
export default connect()(ProductForm);
